// global.jQuery = global.$ = require('jquery');
import 'picturefill';
import './lib/us_player';
import './lib/us_gallery';
import './lib/us_video';
import './lib/us_lazy';
import './lib/us_timeline';
// import sayHello from './lib/sayHello.js';
//
// sayHello();
